var _path, _path2, _path3, _path4, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContractActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 42",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Contract with Sheild") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3.1H11.1C8.6.1,6.5,2.2,6.5,4.8l-.2,26.3H.7C.3,31.1,0,31.5,0,31.9v3.6C0,38.9,2.6,41.7,5.8,41.9v.1h24.9c3.4,0,6.1-2.8,6.1-6.4V12.5h7.4c.4,0,.7-.4.7-.8v-6.7c.2-2.8-2-4.9-4.6-4.9ZM5.9,40.6c-2.6,0-4.6-2.3-4.6-5.2v-3.1h22.8v3c0,1.8.6,3.4,1.8,4.8.1.1.3.2.4.4,0,0-20.4.1-20.4.1ZM35.5,35.6c0,2.7-2.1,5-4.8,5s-4.7-2.2-4.7-5v-3.6c0-.4-.3-.8-.8-.8H7.5l.2-26.6c0-1.8,1.4-3.2,3.2-3.2h26c-.8.9-1.4,2.1-1.4,3.4v30.8ZM43.8,4.8v6h-6.9v-6c0-1.9,1.6-3.4,3.4-3.4,2-.1,3.5,1.5,3.5,3.4Z",
    fill: "#efefef"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9,22.6H12.6c-.4,0-.8.3-.8.6s.3.6.8.6h17.4c.4,0,.8-.3.8-.6s-.4-.6-.9-.6Z",
    fill: "#efefef"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9,27H12.6c-.4,0-.8.3-.8.6s.3.6.8.6h17.4c.4,0,.8-.3.8-.6s-.4-.6-.9-.6Z",
    fill: "#efefef"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3,7.5l-5.3,1v4.5c0,5.3,5.2,7.2,5.2,7.2h.2c.1,0,5.2-1.9,5.2-7.2v-4.6s-5.3-.9-5.3-.9ZM26.1,12.9c0,4.7-4.1,6.4-4.8,6.7-.7-.3-4.8-2.1-4.8-6.7v-4l4.8-.9,4.8.9v4Z",
    fill: "#efefef"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "19.3 12.8 18.9 13.2 21.4 15.7 24.2 10.9 23.7 10.6 21.3 14.8 19.3 12.8",
    fill: "#efefef"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractActive);
export default __webpack_public_path__ + "static/media/contract-active.6a65b925dea3bb2e23d492e5ba36f58e.svg";
export { ForwardRef as ReactComponent };